import { getPortalName } from "@capone/common";

export const CAP_ONE_LOGO_ALT = "Capital One Travel";
export const PRINT = "Print";
export const TITLE = "Itemized hotel receipt";
export const HOTEL_NAME = "Hotel name";
export const GUEST_NAME = "Guest name";
export const CONFIRMATION_NUMBER = "Confirmation #";
export const INVOICE_DATE = "Invoice date";
export const CHECK_IN = "Check-in";
export const CHECKOUT = "Checkout";
export const ACCOMMODATION = "Accommodation";
export const ACCOMMODATION_TOTAL = "Accommodation total*";
export const YOUR_STAY = "Your stay";
export const ROOM = "Room";
export const ROOMS = "Rooms";
export const TOTAL_COST = "Total cost";
export const TOTAL_COST_PER_NIGHT = "Total cost divided per night";
export const MMDDYYYY_FORMAT = "MM/DD/YYYY";
export const TAXES_AND_FEES = "Taxes and fees";
export const TAXES_AND_FEES_TOTAL = "Taxes and fees total";
export const FEES = "Additional fees at check-in";
export const CANCEL_FOR_ANY_REASON = "Cancel For Any Reason";
export const PAYMENT_INFO = "Payment info";
export const DEFAULT_DOC_ID = "itemized-receipt";
export const COPY1 = `*This total reflects your purchase through ${getPortalName()}. Your hotel may provide an itemized receipt for any charges arranged directly with them.`;
export const PRINT_ON_DESKTOP =
  "Please visit the desktop version of the Capital One Travel Portal";
export const TRAVEL_CREDIT_APPLIED = "Capital One Travel Credit Applied";
export const TRAVEL_OFFER_APPLIED = "Capital One Travel Offer Applied";
export const TRAVEL_CREDITS_LINE_ITEM_APPLIED = "Travel credits applied";
export const TRAVEL_OFFER_LINE_ITEM_APPLIED = "Travel offer applied";
export const getNightTotalLabel = (nightNumber: number) =>
  `Night ${nightNumber} total`;
export const COMPLIMENTARY_NIGHT_PILL_PREFIX = "Congrats!";
export const getComplimentaryNightPillText = (numCompNights: number) =>
  `You unlocked ${
    numCompNights === 1
      ? "a complimentary night"
      : `${numCompNights} complimentary nights`
  }`;
